/**
 *
 *
 *
 *
 *
 *
 */
export const useAccessibility = (
  host: HTMLOcSheetV1Element,
  init: {
    headline: () => string | undefined;
    ocAriaLabel: () => string | undefined;
    ocAriaLabelChange: (label: string | undefined) => void;
    shouldUpdate: () => boolean;
  },
): void => {
  $effect(() => {
    if (!init.shouldUpdate()) return;

    init.ocAriaLabelChange(
      init.ocAriaLabel() || host.querySelector(`[slot="headline"]`)?.textContent || init.headline(),
    );
  });
};
